<template>
    <div class="m-mapCollect" id="m-mapCollect">
        <!-- todo -->
<!--        <el-alert-->
<!--            title="几个需确认的点"-->
<!--            type="warning">-->
<!--            <p>1、什么才算未完成和已完成，及未完成在图像库首页的标识</p>-->
<!--        </el-alert>-->

        <div class="page-container">
            <el-tabs v-model="tab" type="border-card">
                <el-tab-pane name="omit" label="漏检图像库">
                    <map-omit
                        ref="omitMap"
                        @omit-select="onOmitSelect"
                    ></map-omit>
                </el-tab-pane>
                <el-tab-pane name="good" label="优质图像库">
                    <map-good
                        ref="goodMap"
                        @good-select="onGoodSelect"
                    ></map-good>
                </el-tab-pane>
            </el-tabs>
        </div>

        <!-- 组题菜单，只在科室展示 -->
        <map-sidebar
            v-if="!isBackend"
            :omitSelected="omitSelectedIds"
            :goodSelected="goodSelectedIds"
            @clear-select="clearSelect"
        >
        </map-sidebar>

        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @onClose="onSubpageClose"></router-view>
        </transition>

        <el-backtop target=".m-mapCollect .page-container"></el-backtop>

    </div>
</template>

<script>
    import MapOmit from "./MapOmit"
    import MapGood from "./MapGood"
    import MapSidebar from "./Components/MapSidebar"

    export default {
        components: {
            MapGood,
            MapOmit,
            MapSidebar
        },

        data() {
            return {
                isBackend: false,  // 是否为后台(身份分为科室和后台)
                tab: 'omit',
                omitSelectedIds: [],
                goodSelectedIds: []
            }
        },

        watch: {
            /**
             * 因为两个菜单共用了同一组件，所以在相互切换的时候需要重新载入页面
             */
            '$route.name': {
                handler(v, oldV) {
                    //console.log(v, oldV)
                    if (oldV==='mapCollectBG' &&  v==='mapCollect'||
                        oldV==='mapCollect' && v==='mapCollectBG' ||
                        ['addOmitMap', 'editOmitMap', 'addGoodMap', 'editGoodMap'].includes(oldV) && v==='mapCollectBG' ||
                        ['addOmitMapBG', 'editOmitMapBG', 'addGoodMapBG', 'editGoodMapBG'].includes(oldV) && v==='mapCollect'
                    ) {
                        window.APP_ROOT.reload()
                    }
                },
                immediate: true
            },
        },

        mounted() {
            this.isBackend = this.$route.name === 'mapCollectBG'
        },

        methods: {
            onOmitSelect(arr) {
                this.omitSelectedIds = arr
            },
            onGoodSelect(arr) {
                this.goodSelectedIds = arr
            },
            clearSelect() {
                this.$refs.omitMap.clearSelect()
                this.$refs.goodMap.clearSelect()
            },

            onSubpageClose() {
                if (this.tab === 'omit') {
                    this.$refs.omitMap.queryMap()
                } else {
                    this.$refs.goodMap.queryMap()
                }
            }
        },
    }
</script>

<style lang="scss">

    @import '~@/style/const.scss';

    $td-height: 120px;

    #m-mapCollect {
        height: 100%;
        @include scrollbar($bgc:#aaa, $width: 10px, $height:12px, $outline: #999);

        .page-container {
            padding: 20px;
            height: 100%;
            overflow: auto;
        }

        .page-query {
            padding: 20px 20px 0 20px;
            margin-bottom: 0;
            box-shadow: none;
        }
        .page-table {
            box-shadow: none;
        }

        // 表格样式
        .map-table {
            td {
                padding: 5px 0;
            }

            .img-map {
                img {
                    max-height: 100px;
                    cursor: pointer;
                }
            }

            .el-table__body-wrapper {
                min-height: calc(100vh - #{$h-header} - #{$h-nav} - 350px);

                td:first-child .cell {
                    padding: 0;
                }

                .el-table-column--selection .el-checkbox {
                    height: $td-height;
                    width: 100%;
                }

                .el-table__empty-block {
                    position: absolute;
                }
            }

            .btn-cell {
                i {
                    display: inline-block;
                    height: $td-height;
                    line-height: $td-height;
                    padding: 0 6px;
                    //font-size: 20px;
                }
                .inuc-delete:hover {
                    color: $red;
                }
            }
        }

    }
</style>
